import { c as _c } from "react/compiler-runtime";
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { ScrollableContent } from '@repo/design-system/components/layout/scrollable-content';
import { Type } from '@repo/design-system/components/ui/type';
import { css } from '@repo/panda/css';
import { DEFAULT_CATEGORY_COLORS } from '@repo/store/maps/utils/categoryColors';
interface CategoryColorPaletteProps {
  selectedColor: string;
  onColorSelect: (color: string) => void;
  label?: string;
}
const colorSwatchStyles = css({
  width: '[32px]',
  height: '[32px]',
  borderRadius: '6',
  border: '[2px solid transparent]',
  cursor: 'pointer',
  transition: '[all 0.2s ease]',
  position: 'relative',
  '&:hover': {
    transform: 'scale(1.1)',
    boxShadow: '[0 4px 12px rgba(0, 0, 0, 0.3)]'
  },
  '&[data-selected="true"]': {
    border: '[2px solid white]',
    boxShadow: '[0 0 0 2px rgba(255, 255, 255, 0.5)]',
    transform: 'scale(1.05)'
  },
  '&[data-selected="true"]::after': {
    content: '""',
    position: 'absolute',
    top: '[50%]',
    left: '[50%]',
    transform: 'translate(-50%, -50%)',
    width: '[12px]',
    height: '[12px]',
    backgroundColor: 'brand.white',
    borderRadius: '[50%]',
    boxShadow: '[0 0 0 1px rgba(0, 0, 0, 0.2)]'
  }
});
export const CategoryColorPalette = t0 => {
  const $ = _c(10);
  const {
    selectedColor,
    onColorSelect,
    label
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = label && <Type variant="inputHint" color="text.secondary">{label}</Type>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onColorSelect || $[3] !== selectedColor) {
    t2 = DEFAULT_CATEGORY_COLORS.map((color, index) => <button key={color} type="button" className={colorSwatchStyles} style={{
      backgroundColor: color
    }} data-selected={selectedColor === color} onClick={() => onColorSelect(color)} aria-label={`Select color ${index + 1}: ${color}`} title={`Select ${color}`} />);
    $[2] = onColorSelect;
    $[3] = selectedColor;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <ScrollableContent maxHeight="120px"><FlexRow gap="4" width="full" wrap="wrap" height="full">{t2}</FlexRow></ScrollableContent>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <FlexColumn gap="4" width="full">{t1}{t3}</FlexColumn>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};